document.addEventListener("DOMContentLoaded", function(event) {
    $(document).ready(function(){

      // if page have featured products 
      if($('.featuredCollectionSlider').length) {
        if($(window).width() >= 750) {
          

            setTimeout(() => {
              $('.featuredCollectionSlider').owlCarousel({
                  loop:true,
                  margin: 24,
                  items:4,
                  nav: true,
                  navText: ["<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' /> ",
                            "<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' />"],
                  dots: false
              });             
            }, 1500);

  
        } else {
  
            $('.featuredCollectionSlider').owlCarousel({
                loop:true,
                margin: 16,
                items:1.2,
                nav: true,
                navText: ["<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' /> ",
                          "<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' />"],
                dots: false
            });

            if($('.collection .collection__view-all').length && $('.collection .quizLink').length) {
              swapElement($('.collection .collection__view-all'),  $('.collection .quizLink'));
            } else {

              if($('.collection .quizLink').length) {
                $('.collection .quizLink').insertAfter('.featuredCollectionSlider');
              } else {
                $('.collection .collection__view-all').appendTo($('.collection .collection__title'))
              }


            }


  
        }
      }
  
    })
  })

  function swapElement(a, b) {
    // create a temporary marker div
    var aNext = $('<div>').insertAfter(a);
    a.insertAfter(b);
    b.insertBefore(aNext);
    // remove marker div
    aNext.remove();
  }
  